import {EntityType, Office, OfficeForm, OfficeIntegrationForm} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {Offices_Read} from "../util/access/Permission";
import api from "../util/api";
import {replaceElement} from "../util/ArrayUtil";

interface OfficeStore extends EntityStore<Office[]> {
    updateOffice: (location: Office, patch: OfficeForm) => Promise<Office>,
    updateOfficeIntegrations: (office: Office, enabled: boolean) => Promise<Office>,
}

export const useOfficeStore = create<OfficeStore>()(
    arrayResource<Office, OfficeStore>(EntityType.Offices, builder => {
        const rest = builder.crud<OfficeForm>('/offices', 'id');

        return {
            remoteValue: builder.all(Offices_Read, () => rest.getAll()),
            updateOffice: builder.updateAndPatch<OfficeForm>(rest),
            updateOfficeIntegrations: async (office, enabled) => {
                const form: OfficeIntegrationForm = {checkInsIntegrationEnabled: enabled};
                const response = await api.patch<Office>(`/offices/${office.id}/integrations`, form);
                const updatedOffice = response.data;
                builder.patch(prevOffices =>
                    replaceElement(prevOffices, oldOffice => oldOffice.id === office.id, updatedOffice)
                );
                return updatedOffice;
            },
        };
    })
);

startEntityStore(useOfficeStore);
